import { render, staticRenderFns } from "./PortfolioBuilder.vue?vue&type=template&id=28fec7bf&scoped=true"
import script from "./PortfolioBuilder.vue?vue&type=script&lang=js"
export * from "./PortfolioBuilder.vue?vue&type=script&lang=js"
import style0 from "./PortfolioBuilder.vue?vue&type=style&index=0&id=28fec7bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fec7bf",
  null
  
)

export default component.exports